import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import IconButton from 'material-ui/IconButton';
import Hamburger from '../Icons/Hamburger';

const styles = () => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    color: '#5F6368',
    fontSize: '20px',
    boxShadow: '0px 3px 6px #0000001A',
    position: 'fixed',
    background: "#FFFFFF",
    zIndex: 2,
  },

  header: {
    display: 'flex',
    padding: '15px 25px',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },

  headerTitle: {
    fontWeight: 'bold',
    padding: '10px 40px 20px 40px',
    letterSpacing: '0.46px',
    textIndent: '0.46px',
  },

  hamburgerBtn: {
    margin: 0,
    borderRadius: '50%',
    minWidth: 'unset',
  },

  headerText: {
    marginRight: '10px',
    letterSpacing: '-0.2px',
    textIndent: '-0.2px',
  },
});

class FaqHeader extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.header}>
          <IconButton
            className={classes.hamburgerBtn}
            onClick={this.props.toggleFaqNavigation}
            color="default"
            aria-label="Back">
            <Hamburger color="#5F6368" width={20} height={20} />
          </IconButton>
          <div style={{ cursor: 'pointer' }} onClick={() => this.props.goTo('/how-to')}>
            <span className={classes.headerText} style={{ marginLeft: 10 }}>Keyman Letter</span>
            <span className={classes.headerText}>ヘルプ</span>
          </div>
        </div>
        {this.props.title && (
          <div className={classes.headerTitle}>
            {this.props.title}
          </div>
        )}

      </div>
    )
  }
}

FaqHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleFaqNavigation: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  goTo: PropTypes.func.isRequired,
};

export default withStyles(styles)(FaqHeader);



// WEBPACK FOOTER //
// ./src/components/Faq/FaqHeader.jsx